(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["review"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.review__content').forEach(function (wrapper) {
      var inner = wrapper.querySelector('.review__content-inner');
      var btn = wrapper.querySelector('.review__voir-plus');
      if (!inner || !btn) return;
      if (inner.scrollHeight > inner.clientHeight) {
        btn.style.display = 'block';
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
